export default "__VITE_ASSET__Cm6v8Mbc__"